<template>
  <span class="n-number-unit">{{ unit }}</span>
</template>

<script setup>
import {computed} from 'vue';
import {useBootstrap} from '@front/hooks';

const props = defineProps({
  cy1: undefined,
  cy2: undefined,
});

const { ENUMS } = useBootstrap();

const unit = computed(() => {
  const currency1 = ENUMS.value.Currency?.find(o => o.name === props.cy1);
  const currency2 = ENUMS.value.Currency?.find(o => o.name === props.cy2);
  const u1 = currency1 ? currency1.label : props.cy1;
  const u2 = currency2 ? currency2.label : props.cy2;
  return u1 + '/' + u2;
});
</script>

<style lang="less">
.n-number-unit {
  font-size: 10px;
  font-weight: bold;
  opacity: 0.6;
}
</style>
